(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__pcSwatchesInit) return;
    window.__pcSwatchesInit = true;
    function pick(sw, e) {
      if (e) { e.preventDefault(); e.stopPropagation(); }
      var card = sw.closest('.product-card');
      if (!card) return;
      var img = card.querySelector('.product-card__media img');
      if (img) {
        img.removeAttribute('loading');
        img.setAttribute('srcset', sw.getAttribute('data-pc-srcset'));
        img.setAttribute('src', sw.getAttribute('data-pc-img'));
      }
      var all = sw.parentNode.querySelectorAll('.pc__swatch');
      for (var i = 0; i < all.length; i++) all[i].classList.toggle('is-active', all[i] === sw);
    }
    document.addEventListener('click', function (e) {
      var sw = e.target.closest && e.target.closest('.pc__swatch');
      if (sw) pick(sw, e);
    }, true);
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      var sw = e.target.closest && e.target.closest('.pc__swatch');
      if (sw) pick(sw, e);
    }, true);
  })();
  } catch(e) { console.error(e); }
})();

})();
